import axios from "axios";
import axiosThrottle from "axios-request-throttle";
import queryString from "query-string";

export const apiClient = axios.create({
	withCredentials: true,
	baseURL: import.meta.env.VITE_PUBLIC_API_BASE_URL || "http://localhost:8000/api/",
	paramsSerializer: {
		serialize(params) {
			return queryString.stringify(params, { arrayFormat: "bracket" });
		},
	},
	timeout: 1000 * 600,
});

// Response interceptor to handle session expiration
apiClient.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response?.status === 401) {
			// Only redirect if this is not the initial profile check
			// The profile endpoint is used for initial auth checking
			const isProfileCheck = error.config?.url?.includes("/profile");

			if (!isProfileCheck) {
				// Session expired during normal operation, redirect to login
				window.location.replace("/login");
			}
		}
		return Promise.reject(error);
	},
);

axiosThrottle.use(apiClient, { requestsPerSecond: 50 });
